/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './survey-question-option.reducer';

export const SurveyQuestionOptionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const surveyQuestionOptionEntity = useAppSelector(state => state.surveyQuestionOption.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="surveyQuestionOptionDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.surveyQuestionOption.detail.title">SurveyQuestionOption</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.surveyQuestionOption.id">Id</Translate>
            </span>
          </dt>
          <dd>{surveyQuestionOptionEntity.id}</dd>
          <dt>
            <span id="weightage">
              <Translate contentKey="tinyMedicRestApp.surveyQuestionOption.weightage">Weightage</Translate>
            </span>
          </dt>
          <dd>{surveyQuestionOptionEntity.weightage}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.surveyQuestionOption.active">Active</Translate>
            </span>
          </dt>
          <dd>{surveyQuestionOptionEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.surveyQuestionOption.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{surveyQuestionOptionEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.surveyQuestionOption.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{surveyQuestionOptionEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.surveyQuestionOption.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{surveyQuestionOptionEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.surveyQuestionOption.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{surveyQuestionOptionEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.surveyQuestionOption.question">Question</Translate>
          </dt>
          <dd>{surveyQuestionOptionEntity.question ? surveyQuestionOptionEntity.question.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.surveyQuestionOption.optionChoice">Option Choice</Translate>
          </dt>
          <dd>{surveyQuestionOptionEntity.optionChoice ? surveyQuestionOptionEntity.optionChoice.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/survey-question-option" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/survey-question-option/${surveyQuestionOptionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SurveyQuestionOptionDetail;
